import tw from "twin.macro";

export const MessageText = tw.p`text-sm font-medium`;
export const SuccessText = tw(MessageText)`text-green-800`;
